import React from 'react';

const ClockOrange = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "32",
    height: "33",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.8542 5.09996H12.1475C11.6142 5.09996 11.1875 4.67329 11.1875 4.13996C11.1875 3.60663 11.6142 3.16663 12.1475 3.16663H19.8542C20.3875 3.16663 20.8142 3.59329 20.8142 4.12663C20.8142 4.65996 20.3875 5.09996 19.8542 5.09996Z",
      fill: "#FFD300"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.6267 20.5H22.7067C21.0133 20.5 20 21.5133 20 23.2067V27.1267C20 28.82 21.0133 29.8333 22.7067 29.8333H26.6267C28.32 29.8333 29.3333 28.82 29.3333 27.1267V23.2067C29.3333 21.5133 28.32 20.5 26.6267 20.5ZM26.2533 26.4467L24.68 27.3533C24.36 27.54 24.04 27.6333 23.7467 27.6333C23.52 27.6333 23.32 27.58 23.1333 27.4733C22.7067 27.22 22.4667 26.7267 22.4667 26.0733V24.26C22.4667 23.6067 22.7067 23.1133 23.1333 22.86C23.56 22.6067 24.1067 22.66 24.68 22.98L26.2533 23.8867C26.8133 24.22 27.1333 24.6733 27.1333 25.1667C27.1333 25.66 26.8267 26.1133 26.2533 26.4467Z",
      fill: "#FFD300"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.6681 27.1266V23.2066C18.6681 20.7933 20.2947 19.1666 22.7081 19.1666H26.6281C26.9347 19.1666 27.2281 19.1933 27.5081 19.2466C27.5347 18.9266 27.5614 18.6066 27.5614 18.2733C27.5614 11.8866 22.3747 6.69995 16.0014 6.69995C9.62807 6.69995 4.44141 11.8866 4.44141 18.2733C4.44141 24.6466 9.62807 29.8333 16.0014 29.8333C17.1347 29.8333 18.2147 29.6466 19.2547 29.3533C18.8814 28.7266 18.6681 27.9799 18.6681 27.1266ZM17.0014 17.8333C17.0014 18.38 16.5481 18.8333 16.0014 18.8333C15.4547 18.8333 15.0014 18.38 15.0014 17.8333V11.1666C15.0014 10.62 15.4547 10.1666 16.0014 10.1666C16.5481 10.1666 17.0014 10.62 17.0014 11.1666V17.8333Z",
      fill: "#FFD300"
    }
  )
);
ClockOrange.displayName = "Icons.ClockOrange";

export { ClockOrange };
//# sourceMappingURL=ClockOrange.js.map
